var React = require('react');

function SplitViewCrosshair (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("path",{"d":"M43 40h39v3H43v39h-3V43H1v-3h39V1h3v39z","id":"a"})),React.createElement("g",{"fill":"none","fillRule":"evenodd","strokeLinecap":"square","key":1},[React.createElement("use",{"fill":"#FFF","xlinkHref":"#a","key":0}),React.createElement("path",{"stroke":"#000","d":"M43.5 39.5h39v4h-39v39h-4v-39H.5v-4h39V.5h4v39z","key":1})])]);
}

SplitViewCrosshair.defaultProps = {"width":"83","height":"83"};

module.exports = SplitViewCrosshair;

SplitViewCrosshair.default = SplitViewCrosshair;
